<!-- eslint-disable @nx/workspace-ebiz-no-inner-html -->
<div
    class="message-container"
    [innerHtml]="'COMPANY_SEARCH.NO_DEALER_WITH_INSTANT_OFFER' | translate"
    (click)="redirectToAppointmentCreation.emit()"
></div>
<!-- eslint-enable @nx/workspace-ebiz-no-inner-html -->
<div class="map-image" [style.background-image]="'url(assets/images/company-search/map-empty.png'"></div>
